//
//
//
//
//
//
//
//

export default {
  data: function data() {
    return {
      left: false
    };
  }
};